import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    padding: '0 16px',
    [theme.breakpoints.down('sm')]: {
      marginTop: 84,
    },
  },
  version: {
    display: 'none',
  },
}), { name: 'RegistrationProcess' });
